import { FollowReplyChannelState } from 'apps/followReply/interfaces'
import { FollowReply } from 'shared/api/common/schemas/flow'

export const NAMESPACE = 'followReply'

export const FLOW_NAME = 'Follow to DM'

export const getFollowReplyChannelDefaultState = (): FollowReplyChannelState => ({
  flowId: null,
  name: '',
  chId: null,
  enabled: null,
  fetching: false,
  isFetched: false,
  delay: 0,
})

export const getChannelState = (followReply: FollowReply): FollowReplyChannelState => {
  return {
    flowId: followReply.flow?.ns ?? null,
    name: followReply.flow?.name ?? '',
    chId: followReply.content_holder ?? null,
    enabled: followReply.enabled ?? null,
    fetching: false,
    isFetched: true,
    delay: followReply.delay ?? 0,
  }
}
